(function () {
  'use strict';
  if (window.__emolieSingle25Initialized) return;
  window.__emolieSingle25Initialized = true;
  var code = 'EMOLIEONE25OCT29A8';
  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (!base.endsWith('/')) base += '/';
  var nativeFetch = window.fetch.bind(window);
  var active = null;
  var rerun = false;
  var timer = null;
  var submitBypass = false;

  function codesApplied(cart) {
    var codes = [];
    (cart.discount_codes || []).forEach(function (c) {
      var value = typeof c === 'string' ? c : c.code;
      if (value) codes.push(value);
    });
    (cart.discount_applications || []).forEach(function (d) {
      if (d.type === 'discount_code' && d.title) codes.push(d.title);
    });
    return codes.filter(function (c, i) {
      return codes.findIndex(function (n) { return n.toLowerCase() === c.toLowerCase(); }) === i;
    });
  }

  function loadCart() {
    return nativeFetch(base + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('cart read failed'); return r.json(); });
  }

  function setCodes(codes) {
    return nativeFetch(base + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) {
      if (!r.ok) throw new Error('discount update failed');
      return r.json();
    });
  }

  function refreshUI() {
    if (location.pathname.endsWith('/cart') || location.pathname.endsWith('/cart/')) {
      location.reload();
      return Promise.resolve();
    }
    if (!document.getElementById('mini-cart')) return Promise.resolve();
    return nativeFetch(base + '?sections=mini-cart', {credentials:'same-origin', cache:'no-store'})
      .then(function(r) { if(!r.ok) return null; return r.json(); })
      .then(function(data) {
        if (!data || !data['mini-cart']) return;
        var parsed = new DOMParser().parseFromString(data['mini-cart'], 'text/html');
        var section = parsed.querySelector('.shopify-section');
        var existing = document.getElementById('mini-cart');
        if (section && existing) existing.innerHTML = section.innerHTML;
      });
  }

  function sync(refresh) {
    if (active) { rerun = true; return active; }
    active = loadCart().then(function(cart) {
      var applied = codesApplied(cart);
      function ours(c) {
        var value = c.toLowerCase();
        return value === code.toLowerCase() || value === 'emolie single-piece 25% price';
      }
      var hasOurs = applied.some(ours);
      var others = applied.filter(function(c){ return !ours(c); });
      if (cart.item_count === 1 && !hasOurs && others.length === 0) {
        return setCodes([code]).then(function(){ return true; });
      }
      if (cart.item_count !== 1 && hasOurs) {
        return setCodes(others).then(function(){ return true; });
      }
      return false;
    }).then(function(changed) {
      if (changed && refresh !== false) return refreshUI();
    }).catch(function(error){
      console.warn('Single item 25% discount synchronization failed', error);
    }).finally(function(){
      active = null;
      if(rerun){ rerun=false; schedule(150); }
    });
    return active;
  }

  function schedule(delay) {
    if (timer !== null) clearTimeout(timer);
    timer = setTimeout(function(){timer=null;sync(true);}, delay || 150);
  }

  // Verify the live cart state before entering checkout, rather than trusting
  // a pending Ajax cart update or the discount code's mere presence.
  function checkoutDiscountIsCorrect(cart) {
    var applied = codesApplied(cart);
    var ours = applied.some(function(c) {
      return c.toLowerCase() === code.toLowerCase() ||
        c.toLowerCase() === 'emolie single-piece 25% price';
    });
    if (cart.item_count !== 1) return !ours;
    var others = applied.filter(function(c) {
      var name = c.toLowerCase();
      return name !== code.toLowerCase() &&
        name !== 'emolie single-piece 25% price';
    });
    if (others.length) return !ours;
    var codeRecords = (cart.discount_codes || []).filter(function(c) {
      return c && typeof c === 'object' &&
        (c.code || '').toLowerCase() === code.toLowerCase();
    });
    if (codeRecords.some(function(c) { return c.applicable === false; })) return false;
    return ours;
  }

  function verifyBeforeCheckout() {
    return sync(false).then(function() {
      return loadCart();
    }).then(function(cart) {
      if (checkoutDiscountIsCorrect(cart)) return true;
      // Give the pending cart synchronization one extra pass if a quick-add
      // or quantity edit was still in flight.
      return sync(false).then(function() { return loadCart(); })
        .then(checkoutDiscountIsCorrect);
    }).catch(function(error) {
      console.warn('Single-piece checkout verification failed', error);
      return false;
    });
  }

  function checkoutWarning() {
    window.alert('Please check your cart and try checkout again. Offer 25% applies to exactly one item only.');
  }

  window.fetch = function(input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var request = nativeFetch.apply(null, arguments);
    var pathname = url.split('?')[0];
    var paths = ['/cart/add.js', '/cart/change.js', '/cart/update.js', '/cart/clear.js'];
    if(paths.some(function(p){ return pathname.endsWith(p); })) {
      request.then(function(res){ if(res && res.ok) schedule(180); }).catch(function(){});
    }
    return request;
  };

  document.addEventListener('cartdrawer:opened', function(){schedule(130);});
  document.addEventListener('cart:updated', function(){schedule(130);});
  document.addEventListener('cart:refresh', function(){schedule(130);});
  window.addEventListener('pageshow', function(){schedule(100);});

  document.addEventListener('submit', function(event) {
    if (submitBypass) return;
    var form = event.target;
    var button = event.submitter;
    if (!form || !button || button.name !== 'checkout') return;
    if (!form.matches('#cart, .mini-cart, form[action*="/cart"]')) return;
    event.preventDefault();
    verifyBeforeCheckout().then(function(ready) {
      if (!ready) { checkoutWarning(); return; }
      submitBypass = true;
      try { form.requestSubmit(button); }
      finally { submitBypass = false; }
    });
  }, true);

  document.addEventListener('click', function(event) {
    var a = event.target && event.target.closest && event.target.closest('a[href]');
    if (!a) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (_) { return; }
    if (url.origin !== location.origin) return;
    if (!url.pathname.endsWith('/checkout') && !url.pathname.endsWith('/checkout/')) return;
    event.preventDefault();
    verifyBeforeCheckout().then(function(ready) {
      if (ready) location.assign(a.href);
      else checkoutWarning();
    });
  }, true);


  // EMOLIE_DIRECT_BUY_NOW_SINGLE_25
  // Shopify's accelerated Buy Now skips the Ajax cart, so the one-piece
  // discount must travel in the direct-to-checkout permalink.
  // Keep add-to-cart unchanged and never attach the code to quantity > 1.
  function emolieMountBuyNowDiscount() {
    document.querySelectorAll('product-form form[data-type="add-to-cart-form"]').forEach(function(form) {
      if (form.dataset.emolieDirectBuyNow === 'true') return;
      if (form.closest('[data-clozs-force-sold-out-form="true"]')) return;
      if (form.querySelector('[name="selling_plan"]')) return;
      var nativePayment = form.querySelector('.shopify-payment-button:not(.emolie-direct-buy-now)');
      var variantInput = form.querySelector('input[name="id"], select[name="id"]');
      if (!nativePayment || !variantInput) return;
      var replacement = document.createElement('div');
      replacement.className = 'shopify-payment-button emolie-direct-buy-now';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'shopify-payment-button__button shopify-payment-button__button--unbranded';
      btn.textContent = 'Buy it now';
      replacement.appendChild(btn);
      nativePayment.insertAdjacentElement('afterend', replacement);
      nativePayment.hidden = true;
      nativePayment.setAttribute('aria-hidden', 'true');
      nativePayment.style.setProperty('display', 'none', 'important');
      form.dataset.emolieDirectBuyNow = 'true';
    });
  }

  document.addEventListener('click', function(event) {
    var button = event.target && event.target.closest &&
      event.target.closest('.emolie-direct-buy-now > button');
    if (!button || button.disabled) return;
    var form = button.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    var variant = form.querySelector('input[name="id"], select[name="id"]');
    var id = variant && String(variant.value).trim();
    var quantityInput = form.querySelector('input[name="quantity"]');
    var qty = quantityInput ? Number(quantityInput.value) : 1;
    var addButton = form.querySelector('button[name="add"]');
    if (!id || !/^\d+$/.test(id) || !Number.isSafeInteger(qty) || qty < 1 ||
        (addButton && (addButton.disabled || addButton.getAttribute('aria-disabled') === 'true'))) {
      window.alert('Please select an available product option before checkout.');
      return;
    }
    var url = base + 'cart/' + id + ':' + qty;
    if (qty === 1) url += '?discount=' + encodeURIComponent(code);
    button.disabled = true;
    window.location.assign(url);
  }, true);

  var emolieBuyNowMountScheduled = false;
  function scheduleEmolieBuyNowMount() {
    if (emolieBuyNowMountScheduled) return;
    emolieBuyNowMountScheduled = true;
    setTimeout(function() {
      emolieBuyNowMountScheduled = false;
      emolieMountBuyNowDiscount();
    }, 60);
  }
  document.addEventListener('shopify:section:load', scheduleEmolieBuyNowMount);
  if (window.MutationObserver) {
    var emolieBuyNowObserver = new MutationObserver(function(records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes && records[i].addedNodes.length) {
          scheduleEmolieBuyNowMount();
          break;
        }
      }
    });
    function beginEmolieBuyNowObserver() {
      scheduleEmolieBuyNowMount();
      if (document.body) {
        emolieBuyNowObserver.observe(document.body, {childList:true, subtree:true});
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', beginEmolieBuyNowObserver, {once:true});
    } else beginEmolieBuyNowObserver();
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', emolieMountBuyNowDiscount, {once:true});
  } else emolieMountBuyNowDiscount();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){schedule(100);}, {once:true});
  } else schedule(100);
})();
